import lax from 'lax.js';

if (document.querySelector('.list-tax-v1')) {
    const isMobile = () => window.innerWidth <= 768;

    // Configurazione per il layout con .container
    const parallaxConfigsContainer = [
        { desktopSpeed: 0.05, mobileSpeed: 0.01 },  // Elemento 1
        { desktopSpeed: 0.08, mobileSpeed: 0.03 },  // Elemento 2
        { desktopSpeed: 0.07, mobileSpeed: 0.02 }, // Elemento 3
        { desktopSpeed: 0.09, mobileSpeed: 0.03 },  // Elemento 4
        { desktopSpeed: 0.11, mobileSpeed: 0.035 },  // Elemento 5
        { desktopSpeed: 0.1, mobileSpeed: 0.03 },  // Elemento 6
        { desktopSpeed: 0.15, mobileSpeed: 0.02 }, // Elemento 7
        { desktopSpeed: 0.2, mobileSpeed: 0.03 }   // Elemento 8
    ];

    // Configurazione per il layout con .container-xl
    const parallaxConfigsContainerXL = [
        { desktopSpeed: 0.05, mobileSpeed: 0.01 },  // Elemento 1
        { desktopSpeed: 0.08, mobileSpeed: 0.03 },  // Elemento 2
        { desktopSpeed: 0.07, mobileSpeed: 0.02 }, // Elemento 3
        { desktopSpeed: 0.09, mobileSpeed: 0.03 },  // Elemento 4
        { desktopSpeed: 0.11, mobileSpeed: 0.035 },  // Elemento 5
        { desktopSpeed: 0.1, mobileSpeed: 0.03 },  // Elemento 6
        { desktopSpeed: 0.15, mobileSpeed: 0.02 }, // Elemento 7
        { desktopSpeed: 0.2, mobileSpeed: 0.03 }   // Elemento 8
    ];

    window.onload = function() {
        // Inizializza lax
        lax.init();

        // Aggiungi il driver di scroll
        lax.addDriver('scrollY', function() {
            return window.scrollY;
        });

        // Funzione per configurare il parallasse
        const setupParallax = (element, config) => {
            lax.addElement(element, {
                scrollY: {
                    translateY: [
                        ['elInY', 'elOutY'],
                        [0, `${isMobile() ? config.mobileSpeed : config.desktopSpeed}*elOutY`],
                    ]
                }
            });
        };

        // Funzione per applicare il parallasse a tutti gli elementi
        const applyParallax = () => {
            // Rimuovi gli elementi esistenti prima di riapplicare
            lax.removeElements('.parallax-v1');

            const listTaxLists = document.querySelectorAll('.list-tax__list');
            
            listTaxLists.forEach(listTaxList => {
                const childDiv = listTaxList.querySelector('div');
                let parallaxConfigs;

                if (childDiv.classList.contains('container')) {
                    parallaxConfigs = parallaxConfigsContainer;
                } else if (childDiv.classList.contains('container-xl')) {
                    parallaxConfigs = parallaxConfigsContainerXL;
                } else {
                    return;
                }

                const elements = listTaxList.querySelectorAll('.parallax-v1');
                elements.forEach((element, index) => {
                    const configIndex = index % parallaxConfigs.length;
                    setupParallax(element, parallaxConfigs[configIndex]);
                });
            });
        };

        // Applica inizialmente il parallasse
        applyParallax();

        // Gestione del resize con debounce
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                applyParallax();
                lax.updateElements();
            }, 250);
        });
    }
}
